import React from "react";
import { Link } from "gatsby";
import { twMerge } from "tailwind-merge";

interface NavLinkProps {
  children: React.ReactNode;
  target: string;
  internalPath?: string;
  externalUrl?: string;
  className?: string;
  boldText?: boolean;
  secondary?: boolean;
  icon?: { url: string; width: string; height: string };
}

const NavLink = ({
  children,
  target,
  internalPath,
  externalUrl,
  className,
  boldText,
  secondary,
  icon,
}: NavLinkProps) => {
  const baseClasses =
    "flex items-center font-body tracking-wide text-extraDarkPurple hover:underline";
  const textWeightClass = boldText ? "font-medium" : "font-light";
  const textSizeClass = secondary ? "text-base" : "text-xl";
  const combinedClasses = twMerge(
    baseClasses,
    textWeightClass,
    textSizeClass,
    className
  );

  const linkContent = (
    <>
      {icon && (
        <img
          src={icon.url}
          alt=""
          height={icon.height}
          width={icon.width}
          className="mr-2 h-8 w-8"
        />
      )}
      {children}
    </>
  );

  return internalPath ? (
    <Link to={internalPath} target={target} className={combinedClasses}>
      {linkContent}
    </Link>
  ) : (
    <a
      href={externalUrl}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      className={combinedClasses}
    >
      {linkContent}
    </a>
  );
};

export default NavLink;
